import * as React from "react";
import { UitkSelect } from "uitk-react-select";
import { BrandDropdownProps } from "components/flexComponents/WizardCarPWA/typings";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { observer } from "mobx-react";
import { CarVendorInformation } from "src/stores/wizard/config/staticConfigs/car/typings";
import { useLocalization } from "@shared-ui/localization-context";

export const BrandDropdown = observer((props: BrandDropdownProps) => {
  const vendorsFromConfig: CarVendorInformation[] = props.lobState.config.vendors;
  const vendorList: CarVendorInformation[] = Object.values(vendorsFromConfig).filter((vendor: CarVendorInformation) => {
    return vendor.includeInDropdown;
  });
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan={props.colSpan}>
      <div>
        <UitkSelect
          label={props.label}
          aria-label={props.label}
          onChange={props.lobState.setPreferredBrand}
          value={props.lobState.preferredBrand}
        >
          {vendorList.map((opt) => (
            <option value={opt.vendorCode} key={opt.vendorCode}>
              {formatText(opt.locKey)}
            </option>
          ))}
        </UitkSelect>
        <input type="hidden" name="vend" value={props.lobState.preferredBrand} />
      </div>
    </UitkLayoutGridItem>
  );
});
